<template>
  <div class="flex flex-col items-center justify-center px-6 py-14 text-center">
    <div class="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100 text-slate-400 dark:bg-slate-700 dark:text-slate-500">
      <AppIcon :name="icon" :size="26" />
    </div>
    <h3 class="text-base font-bold text-slate-800 dark:text-slate-100">{{ title }}</h3>
    <p v-if="text" class="mt-1 max-w-sm text-sm text-slate-500 dark:text-slate-400">{{ text }}</p>
    <div v-if="$slots.default" class="mt-4"><slot /></div>
  </div>
</template>

<script>
import AppIcon from './AppIcon.vue'

export default {
  name: 'EmptyState',
  components: { AppIcon },
  props: {
    icon: { type: String, default: 'file' },
    title: { type: String, default: 'Aucun résultat' },
    text: { type: String, default: '' }
  }
}
</script>
